import { GameResultModel } from "@/models/calendar/GameResultModel";
import { CrudApi } from "./CrudApi";

export class GameResultApi extends CrudApi<GameResultModel>{
	constructor(protected parentResource: string, protected parentId: string, protected calendarId: string, protected eventRootId: string) {
		super(`${parentResource}/${parentId}/calendar/${calendarId}/calendarEvent/${eventRootId}/gameResult`, (obj) => new GameResultModel().load(obj));
	}
}